// extracted by mini-css-extract-plugin
export default {"container":"_295y9","openedContainer":"_32zFE","closeButton":"_2h0kh"};